import { Lang, ThemeMode } from '@/store/types';

const state = {
    token: '',
    userLang: Lang.system,
    // userLang: Lang.enUS,
    userThemeMode: ThemeMode.system,
};

const mutations = {
    SetAny: (state, objData) => {
        if (Object.prototype.toString.call(objData) === '[object Object]') {
            Object.keys(objData).forEach((key) => {
                state[key] = objData[key];
            });
        }
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
